import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from '@library';
import useAssetDownload from '../../../core/hooks/useAssetDownload';
import type { Bicycle } from '../../types';

const DownloadSparePartPdfButton = memo(({ bicycle }: { bicycle: Bicycle }) => {
    const { download, loading } = useAssetDownload(
        bicycle.sparePartDocument ?? '',
        [
            bicycle.manufacturerName,
            bicycle.type,
            bicycle.model,
            bicycle.manufacturingStartYear,
        ].join('_') + '.pdf'
    );

    if (!bicycle.sparePartDocument) {
        return null;
    }
    return (
        <LinkButton
            loading={loading}
            outline
            secondary
            href={bicycle.sparePartDocument}
            download={bicycle.sparePartDocument}
            onClick={async e => {
                e.preventDefault();
                e.stopPropagation();
                await download();
            }}
        >
            <FormattedMessage id="download" />
        </LinkButton>
    );
});

export default DownloadSparePartPdfButton;
